export default function CompanyOverview() {
  return (
    <section className="py-36 bg-gradient-to-b from-[#0A1F1F] to-[#0D9488]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-4xl">
          <span className="text-sm font-medium text-[#5EEAD4] mb-4 block">회사 소개</span>
          <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-8">
            AI와 데이터로<br />
            현장의 문제를 해결하는<br />
            R&D 기술 파트너
          </h1>
          <p className="text-lg text-gray-200 leading-relaxed mb-12">
            4-lab은 공공기관과 기업의 복잡한 과제를 분석하고,<br />
            AI·데이터 기반 연구개발부터 실증·운영까지 연결되는<br />
            실행 가능한 솔루션을 제공합니다.<br />
            기획·설계·개발 역량을 바탕으로 프로젝트를 "끝까지" 완수합니다.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="text-4xl font-bold text-white mb-2">10+</div>
              <div className="text-sm text-gray-200">글로벌 기업 DX 프로젝트 수행</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="text-4xl font-bold text-white mb-2">100+</div>
              <div className="text-sm text-gray-200">프로젝트 완료</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="text-4xl font-bold text-white mb-2">40</div>
              <div className="text-sm text-gray-200">전문 인력</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
